/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { Helmet } from "react-helmet-async";
import { LpMetaProps } from "../../../../../types/LpMetaProps";
import { gaSet } from "../../../../../services/googleAnalyticsService";

const LpDivorcePetitionMeta = ({ keyword }: LpMetaProps) => {
  const title = keyword + " bei Legalbird | schnell & professionell!";
  gaSet({ title: title });

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content="Reichen Sie Ihren Scheidungsantrag online ein - schnell, einfach und nirgendwo günstiger!" />
      <meta name="keywords" content="Scheidungsantrag, Scheidung, einreichen" />
      <meta name="robots" content="noindex,nofollow" />
      <meta property="og:title" content={title} />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:type" content="website" />
      <meta property="og:description" content="Reichen Sie Ihren Scheidungsantrag online ein - schnell, einfach und nirgendwo günstiger!" />
    </Helmet>
  );
};

export default LpDivorcePetitionMeta;
